<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-5">
        <icon-settings :width="22" :height="22" />설정
      </v-col>
    </v-row>

    <!-- 설정 메뉴목록 -->
    <v-list class="settings-list">
      <v-list-item-group>
        <v-list-item v-for="(item, i) in items" :key="i" @click="goPage(item)">
          <v-list-item-content>
            <v-list-item-title
              v-text="item.title"
              class="setting-title"
            ></v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-row class="ma-0">
      <v-col cols="12" class="logout-link" @click="userLogout">로그아웃</v-col>
    </v-row>
  </div>
</template>

<script>
/* 설정메뉴 */
import IconSettings from '@/assets/customIcon/IconSettings.vue';
import routerConstants from '@/const/routerConstants';
import { callApp } from '@/utils/app/callApp.js';
import { logout, getMobileInfo } from '@/api/auth';

export default {
  data: () => ({
    items: [
      {
        title: '비밀번호 변경',
        pageName: routerConstants.PasswordChange,
      },
      {
        title: '서비스 이용약관',
        pageName: routerConstants.ServicePolicy,
      },
      {
        title: '개인정보처리방침',
        pageName: routerConstants.PrivacyPolicy,
      },
      {
        title: '앱 버전 정보',
        pageName: 'checkAppVersion',
      },
    ],
  }),
  methods: {
    /* 화면이동 */
    async goPage(item) {
      if (item.pageName === 'checkAppVersion') {
        try {
          const response = await getMobileInfo({});
          alert(`현재 버전 ${response.data.data.appVersion}`);
        } catch (error) {
          console.log(error);
        }
      } else {
        this.$router.push({ name: item.pageName });
      }
    },
    /* 로그아웃 */
    async userLogout() {
      try {
        const response = await logout();

        if (response.data.message === 'OK') {
          this.$store.commit('cleanToken');
          if (process.env.NODE_ENV == 'production') {
            callApp.logout();
          } else if (process.env.NODE_ENV == 'development') {
            callApp.logout(); // eony개발용
            this.$router.push('/login');
          }
        } else {
          alert('잠시 후 다시 시도해주세요.');
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: { IconSettings },
};
</script>

<style>
.col.logout-link {
  padding: 0px 40px;
  margin-top: 50px;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #777e87;
  text-decoration: underline;
  cursor: pointer;
}
</style>
